import React from 'react';
import PropTypes from 'prop-types';
import Link from '../../Link/Link';
import ExternalLinkIcon from '../../../icons/icon-external-link.svg';
import InfoModal from '../../InfoModal/InfoModal';
import getAddOnHeader from '../helpers/getAddOnHeader';
import createUniqueId from '../../../helpers/createUniqueId';
import AddOnIcon from '../../AddOnIcon/AddOnIcon';
import Checkbox from '../../Checkbox/Checkbox';
import { modify } from '../../../helpers/classNameHelper';
import creditMessageFormatter from '../../../helpers/creditMessageFormatter';
import getBillCreditAmount from '../helpers/getBillCreditAmount';


const ProgramAddOn = ({
  item,
  addOn,
  addOn: {
    content: {
      disclaimer,
      subtitleModalTrigger,
      modalBody,
      icon,
      moreInfoLinkTo,
      moreInfoText,
      title,
      subtitlePrefix,
    },
    id,
  },
  isSelected,
  lineItemPrice,
  lineItemRebatesApplied,
  onChangeHandler,
  optionRebatesApplied,
  productPrice,
  styleFlag,
  uniqueId,
  uuid,
}) => {

  const tooltip = modalBody && { message: modalBody };
  const callToActionHeader = getAddOnHeader({
    addOn,
    lineItemPrice,
    lineItemRebatesApplied,
    optionRebatesApplied,
    productPrice,
  });

  const labelId = callToActionHeader ? createUniqueId(id, `_label_${uuid}`) : undefined;
  const labelClass = modify('product-addon__checkbox', {
    checked: isSelected,
    styleFlag,
  });

  let prefixMessage = subtitlePrefix;



  if (addOn.content.isBillCreditApplicable) {
    const { price, rebatePrice } = item
    const billCreditAmount = getBillCreditAmount
      ({ ...addOn, rebates: optionRebatesApplied },
        { rebates: lineItemRebatesApplied },
        price,
        rebatePrice)
    if (billCreditAmount) {
      prefixMessage = creditMessageFormatter(addOn, billCreditAmount.onElecticity, prefixMessage);
    }
  }

  return (
    <Checkbox
      id={uniqueId}
      className={labelClass}
      isSelected={isSelected}
      focusRingClass="product-addon__checkbox--focused"
      onChange={onChangeHandler}
    >
      <>
        <div className="product-addon__text">
          {callToActionHeader && (
            <div className="product-addon__text-header product-addon__text-header--program" id={labelId}>
              <AddOnIcon className="product-addon__icon product-addon__icon--program" type={icon} />
              {callToActionHeader}
            </div>
          )}
          <div className="info_modal--addon__trigger-label">{prefixMessage ? prefixMessage : "When you enroll in"} </div>
          <InfoModal
            styleFlag="addon"
            message={tooltip.message}
            contentLabel="Add On Program"
            subheader="Save when you enroll in"
            header={title}
            headerIcon={<AddOnIcon type={icon} />}
          >
            {subtitleModalTrigger}
          </InfoModal>
        </div>
        <div className="product-addon__subtext">
          {disclaimer}
          &nbsp;
          {moreInfoLinkTo && (
            <Link
              external
              href={moreInfoLinkTo}
              className="product-addon__link"
            >
              {moreInfoText}
              <ExternalLinkIcon className="product-addon__link-icon" />
            </Link>
          )}
        </div>
      </>
    </Checkbox>
  );
};

ProgramAddOn.propTypes = {
  addOn: PropTypes.shape({
    content: PropTypes.shape({
      bonus: PropTypes.shape({
        rebateValue: PropTypes.number,
      }),
      subtitleModalTrigger: PropTypes.string,
      disclaimer: PropTypes.string,
      modalBody: PropTypes.string,
      icon: PropTypes.string,
      moreInfoLinkTo: PropTypes.string,
      moreInfoText: PropTypes.string,
      title: PropTypes.string,
      subtitlePrefix: PropTypes.string,
      isBillCreditApplicable: PropTypes.shape({
        message: PropTypes.string,
        rebateAppliedMessage: PropTypes.string
      })
    }),
    id: PropTypes.string.isRequired,
    rebates: PropTypes.array
  }).isRequired,
  isSelected: PropTypes.bool,
  lineItemPrice: PropTypes.string,
  lineItemRebatesApplied: PropTypes.arrayOf(PropTypes.shape({})),
  onChangeHandler: PropTypes.func.isRequired,
  optionRebatesApplied: PropTypes.arrayOf(PropTypes.shape({})),
  productPrice: PropTypes.number.isRequired,
  styleFlag: PropTypes.string,
  uniqueId: PropTypes.string.isRequired,
  uuid: PropTypes.string,
  item: PropTypes.shape({
    price: PropTypes.shape({
      sales: PropTypes.shape({
        value: PropTypes.number
      })
    }),
    rebatePrice: PropTypes.shape({
      sales: PropTypes.shape({
        value: PropTypes.number
      })
    })
  })
};

ProgramAddOn.defaultProps = {
  isSelected: false,
  lineItemPrice: '',
  lineItemRebatesApplied: [],
  optionRebatesApplied: [],
  styleFlag: null,
  uuid: '',
  subtitlePrefix: undefined,
  isBillCreditApplicable: null,
  item: {
    price: { sales: { value: 0 } },
    rebatePrice: { sales: { value: 0 } }
  }
};

export default ProgramAddOn;
